<template>
  <div>
    <common-dialog
      ref="dialog"
      width="700px"
      show-save-button
      unit="节次"
      id-key="SectionId"
      :data="data"
      form-label-width="90px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      :before-save="onBeforeSave"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @closed="reset"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="学期名称" prop="TermId" class="longLabel">
              <el-select v-model="data.TermId" size="mini" @change="termChange" :style="isMB?'':'width:190px;'" v-if="isCreate">
                <el-option v-for="item in termList" :key="item.TermId" :value="item.TermId" :label="item.TermName"></el-option>
              </el-select>
              <span>{{data.TermName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="年级" prop="GradeId" class="longLabel">
              <el-select v-model="data.GradeId" size="mini" @change="gradeChange" v-if="isCreate" :style="isMB?'':'width:190px;'">
                <el-option v-for="item in gradeList" :key="item.GradeId" :value="item.GradeId" :label="item.Grade"></el-option>
              </el-select>
              <span v-else>{{data.Grade}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="序号" prop="SectionNumber" class="longLabel">
              <!-- <el-select v-model="data.SectionNumber" size="mini" :style="isMB?'':'width:190px;'" @change="secChange">
                <el-option v-for="item in 10" :value="item" :key="item"></el-option>
              </el-select> -->
              {{data.SectionNumber}}
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="节次" class="longLabel">
              <!-- <el-input size="mini" v-model="data.SectionName" placeholder="请填写节次" :style="isMB?'':'width:190px;'"></el-input> -->
              <span>{{data.SectionName}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="开始时间" prop="StartTime" class="longLabel">
               <el-time-picker
                v-model="t1"
                format="HH:mm"
                size="mini"
                :style="isMB?'width:auto;':'width:190px;'"
                placeholder="请选择开始时间">
              </el-time-picker>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="结束时间" prop="EndTime" class="longLabel">
               <el-time-picker
                v-model="t2"
                format="HH:mm"
                size="mini"
                :style="isMB?'width:auto;':'width:190px;'"
                placeholder="请选择结束时间">
              </el-time-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="点名开始时间" prop="RollCallStartTime" class="longLabel">
               <el-time-picker
                v-model="t3"
                format="HH:mm"
                size="mini"
                :style="isMB?'width:auto;':'width:190px;'"
                placeholder="请选择开始时间">
              </el-time-picker>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="点名结束时间" prop="RollCallEndTime" class="longLabel">
               <el-time-picker
                v-model="t4"
                format="HH:mm"
                size="mini"
                :style="isMB?'width:auto;':'width:190px;'"
                placeholder="请选择结束时间">
              </el-time-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import termApi from "@/api/ed/term";
import gradeApi from "@/api/ed/grade";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        SectionId: 0,
        SectionName: "",
        TermId: null,
        TermName: "",
        GradeId: null,
        Grade: "",
        TermNumber: "",
        StartTime: "",
        EndTime: "",
        RollCallStartTime: "",
        RollCallEndTime: "",
        SectionNumber: null,
      },
      api: require("@/api/ed/section").default,
      termApi,
      gradeApi,
      isMB: this.$store.state.isMB,
      t1: "",
      t2: "",
      t3: "",
      t4: "",
      termList: [],
      gradeList: [],
      isMB: this.$store.state.isMB,
      isCreate: false,
      rules: {
        SectionName: [{ required: true, message: "请填写节次" }],
        TermId: [{ required: true, message: "请选择学期" }],
        GradeId: [{ required: true, message: "请选择年级" }],
        SectionNumber: [{ required: true, message: "序号不能为空" },{ validator: this.$commonJs.validateRules.int }],
        // StartTime: [{ required: true, message: "请选择开始时间" }],
        // EndTime: [{ required: true, message: "请选择结束时间" }],
        // RollCallStartTime: [{ required: true, message: "请选择点名开始时间" }],
        // RollCallEndTime: [{ required: true, message: "请选择点名结束时间" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {
      this.t1 = ""
      this.t2 = ""
      this.t3 = ""
      this.t4 = ""
      this.isCreate = true
      this.getOption()
    },
    gradeChange(e) {
      this.data.SectionNumber = null
      this.data.SectionName = ""
      this.getMaxNumber(this.data.TermId,e)
    },
    getMaxNumber(tid,gid) {
      this.api.getMaxNumber(tid,gid).then(res => {
        this.data.SectionNumber = res.Data
        this.secChange(res.Data)
      })
    },
    onEditOpened(row) {
      this.isCreate = false
      this.t1 = 'Wed Mar 24 2021 ' + row.StartTime
      this.t2 = 'Wed Mar 24 2021 ' + row.EndTime
      this.t3 = 'Wed Mar 24 2021 ' + row.RollCallStartTime
      this.t4 = 'Wed Mar 24 2021 ' + row.RollCallEndTime
      this.getOption()
    },
    getOption() {
      this.termApi.list().then(res => {
        this.termList = res.Data || []
        this.data.TermId = Number(sessionStorage.getItem("termId"))
        this.data.TermNumber = sessionStorage.getItem("termNumber")
      })
      this.gradeApi.list().then(res => {
        this.gradeList = res.Data
      })
    },
    onBeforeSave() {
      if(!this.t1) {
        this.$message.error("请选择开始时间")
        return false
      }
      if(!this.t2) {
        this.$message.error("请选择结束时间")
        return false
      }
      if(!this.t3) {
        this.$message.error("请选择点名开始时间")
        return false
      }
      if(!this.t4) {
        this.$message.error("请选择点名结束时间")
        return false
      }
      this.data.StartTime = this.cutTime(this.t1)
      this.data.EndTime = this.cutTime(this.t2)
      this.data.RollCallStartTime = this.cutTime(this.t3)
      this.data.RollCallEndTime = this.cutTime(this.t4)
    },
    termChange(e) {
      this.termList.forEach(item => {
        if(e == item.TermId) {
          this.data.TermNumber = item.TermNumber
        }
      })
      if(this.data.GradeId) {
        this.data.SectionNumber = null
        this.data.SectionName = ""
        this.getMaxNumber(e,this.data.GradeId)
      }
    },
    cutTime(time) {
      let str = (String(time).split(" ")[4]).split(":")
      return str[0] + ':' + str[1]
    },
    onTermDialog() {
      this.$refs.termDialog.open().then((that) => {
        that.getData();
      });
    },
    secChange(e) {
      this.data.SectionName = "第" + e + "节课"
    },
    reset() {
      this.isCreate = false
    }
  },
};
</script>
<style lang="scss">
</style>